import useStore from "../../../store"
import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import NAPWorkflow from "./NAPWorkflow"
import { useTranslation } from "react-i18next"
import { Wizard, WizardHeader } from "../../ui/wizard"

export default function NAP({ issues = false }) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const {
    NAPBlackbook,
    currentStep,
    setCurrentStep,
    NAPIssues,
    NAPRequiresBankPayoff,
    setTopNavHidden,
    setNavBarHidden,
    setNAPWorkflowLength,
    submittingNap
  } = useStore()

  const [workflow, setWorkflow] = useState([])

  useEffect(() => {
    setWorkflow(NAPWorkflow(NAPIssues, issues, NAPRequiresBankPayoff))
  }, [NAPRequiresBankPayoff])

  useEffect(() => {
    if (!NAPBlackbook) { navigate('/blackbook') }
  }, [])

  useEffect(() => {
    setTopNavHidden(true)
    if (currentStep === workflow.length - 1) {
      setNavBarHidden(true)
    }

    return () => {
      setTopNavHidden(false)
      setNavBarHidden(false)
    }
  }, [currentStep])

  useEffect(() => {
    setNAPWorkflowLength(workflow.length)
  }, [workflow])

  const handleBack = () => {
    if (currentStep <= 0) {
      window.history.back()
    } else {
      setCurrentStep(currentStep - 1)
    }
  }

  return(
    <Wizard>
      <WizardHeader
        title={issues ? t('Edit Floor Request') : t('Request Floor')}
        progress={workflow.length > 0 ? ((currentStep + 1) / workflow.length * 100) : 0}
        showBackButton={!submittingNap && currentStep !== workflow.length - 1}
        handleBack={handleBack}
      />
      {workflow[currentStep]}
    </Wizard>
  )
}